__turbopack_context__.v({
  "actionIcon": "ButtonGrid-module__S7S5mq__actionIcon",
  "button": "ButtonGrid-module__S7S5mq__button",
  "buttonActive": "ButtonGrid-module__S7S5mq__buttonActive",
  "buttonLabel": "ButtonGrid-module__S7S5mq__buttonLabel",
  "grid": "ButtonGrid-module__S7S5mq__grid",
  "iconWrap": "ButtonGrid-module__S7S5mq__iconWrap",
  "magnifierIcon": "ButtonGrid-module__S7S5mq__magnifierIcon",
  "root": "ButtonGrid-module__S7S5mq__root",
});
